import { ResponsiveTable } from "../../../components/mobile/ResponsiveTable";
/** 手机记录列表复用原有数据、勾选与业务操作；普通记录按字段卡片呈现，交互表头和对比矩阵保留横向浏览。 */
import React from "react";
import { useApp } from "../../../context/AppContext";
import Avatar from "../../../components/Avatar";
import { Progress, formatProgress } from "./meta";
import { ListTodo, Landmark } from "lucide-react";
import { T, TN } from "../../../lib/i18n";

const ROLE_ZH = { design_manager: "设计部经理", us_coordinator: "美国建筑设计师", us_policy: "美国建筑设计师", cn_architect: "中国建筑设计师", cn_concept: "中国建筑设计师", cn_drafter: "中国建筑设计师", admin: "管理员" };

/* 负责人负载：设计部全部员工按所属分公司分组；行点击 → 该负责人项目列表 */
export function OwnerLoad({ groups = [], unassigned, go }) {
  const { avatarFor, lang } = useApp();
  const zh = lang === "zh";
  const Row = ({ o }) => {
    const key = encodeURIComponent(o.owner);
    const fk = o.filterKey === "cd" ? "cd" : "owner";  // 中国建筑设计师按 cdDesigner 筛选
    return (
      <tr data-testid={`dv3-owner-${o.owner}`} role="button" tabIndex={0} title={T("点击查看该负责人的项目")} onClick={() => go(`${fk}=${key}`)}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); go(`${fk}=${key}`); } }}
        className={`border-b border-slate-50 last:border-0 cursor-pointer hover:bg-slate-50 transition-colors group ${o.count === 0 ? "opacity-60" : ""}`}>
        <td className="py-1.5">
          <div className="flex items-center gap-2 min-w-0">
            <Avatar src={avatarFor(o.owner) || o.avatar} name={o.owner} size={24} />
            <div className="min-w-0">
              <p className="font-semibold text-slate-800 group-hover:text-violet-700 truncate leading-tight">{TN(o.owner)}</p>
              {(o.position || o.role) && <p className="text-[10px] text-slate-400 leading-tight truncate">{o.position || (zh ? ROLE_ZH[o.role] || o.role : o.role)}</p>}
            </div>
            {o.openTasks > 0 && <span data-testid={`dv3-owner-${o.owner}-tasks`} title={T("待办任务 {0}", [o.openTasks])} className="ml-1 inline-flex items-center gap-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-violet-50 text-violet-700 shrink-0"><ListTodo className="h-3 w-3" />{o.openTasks}</span>}
          </div>
        </td>
        <td className="py-1.5 text-right">{o.count}</td>
        <td className="py-1.5"><div className="flex items-center gap-2"><Progress v={o.avg} /><span className="w-8 text-right">{formatProgress(o.avg)}</span></div></td>
        <td className={`py-1.5 text-right ${o.correction ? "text-orange-700 font-semibold" : "text-slate-400"}`}>{o.correction}</td>
      </tr>
    );
  };
  return (
    <ResponsiveTable className="w-full text-xs" data-testid="dv3-owner-table">
      <thead><tr className="text-[10px] text-slate-400 text-left border-b border-slate-100"><th className="py-1">{T("负责人")}</th><th className="py-1 text-right">{T("项目")}</th><th className="py-1 w-40">{T("平均进度")}</th><th className="py-1 text-right">{T("整改项")}</th></tr></thead>
      {groups.map((g) => (
        <tbody key={g.key} data-testid={`dv3-owner-group-${g.key}`}>
          <tr className="bg-slate-50/80">
            <td colSpan={4} className="py-1 px-1 text-[10px] font-bold text-slate-500 uppercase tracking-wide">
              <span className="inline-flex items-center gap-1"><Landmark className="h-3 w-3 text-violet-400" />{zh ? g.name : g.en}</span>
              <span className="ml-2 font-normal normal-case text-slate-400">{T("{0} 人 · {1} 个项目", [g.staff, g.projects])}{g.openTasks ? T(" · 待办 {0}", [g.openTasks]) : ""}</span>
            </td>
          </tr>
          {g.rows.map((o) => <Row key={`${g.key}-${o.owner}`} o={o} />)}
        </tbody>
      ))}
      {unassigned && <tbody data-testid="dv3-owner-group-unassigned"><tr className="bg-amber-50/60"><td colSpan={4} className="py-1 px-1 text-[10px] font-bold text-amber-700">{T("未指派负责人")}</td></tr><Row o={unassigned} /></tbody>}
      {groups.length === 0 && !unassigned && <tbody><tr><td colSpan={4} className="py-4 text-center text-slate-400">{T("暂无设计部员工档案")}</td></tr></tbody>}
    </ResponsiveTable>
  );
}
